// Replace `color` swatches with real optimized WebP images once
// client-authorized photography is available. Each item keeps its
// category for the Gallery page filters and its alt text for a11y.
const gallery = [
  {
    id: "g1",
    img: "/gymimages/gym1.png",
    category: "Gym Interior",
    alt: "Wide view of the Firm Fit Factory training floor",
    tone: "1",
  },
  {
    id: "g2",
    img: "/gymimages/gym2.png",
    category: "Equipment",
    alt: "Rack of weight plates and barbells",
    tone: "2",
  },
  {
    id: "g3",
    img: "/gymimages/gym3.png",
    category: "Training",
    alt: "Member performing a coached strength session",
    tone: "3",
  },
  {
    id: "g4",
    img: "/gymimages/gym5.jpg",
    category: "Members",
    alt: "Members training together on the gym floor",
    tone: "4",
  },
  {
    id: "g5",
    img: "/gymimages/gym6.jpg",
    category: "Equipment",
    alt: "Row of cardio machines",
    tone: "2",
  },
  {
    id: "g6",
    img: "/gymimages/gym7.webp",
    category: "Events",
    alt: "Group fitness event at the gym",
    tone: "5",
  },
  {
    id: "g7",
    img: "/gymimages/gym8.jpg",
    category: "Gym Interior",
    alt: "Functional training zone with kettlebells",
    tone: "1",
  },
  {
    id: "g8",
    img: "/gymimages/gym9.jpg",
    category: "Training",
    alt: "One-on-one personal training session",
    tone: "3",
  },
  {
    id: "g9",
    img: "/gymimages/gym10.jpg",
    category: "Members",
    alt: "Member completing a lifting set",
    tone: "4",
  },
  {
    id: "g10",
    img: "/gymimages/gym11.png",
    category: "Equipment",
    alt: "Dumbbell rack close-up",
    tone: "2",
  },
  {
    id: "g11",
    img: "/gymimages/gym13.png",
    category: "Events",
    alt: "Members at a gym community event",
    tone: "5",
  },
  {
    id: "g12",
    img: "/gymimages/gym14.png",
    category: "Gym Interior",
    alt: "Entrance area of Firm Fit Factory",
    tone: "1",
  },
];

export default gallery;
